import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './EditionsSection.scss';
import ComparisonTableBlock from '../../Blocks/ComparisonTable/ComparisonTableBlock';

interface IEditionsSectionProps {
  context?: IContent;
}

const EditionsSection = ({ context }: IEditionsSectionProps) => {
  return (
    <div className="section-editions">
      <ComparisonTableBlock />
    </div>
  );
};

export default withContent(EditionsSection);
